// get the element to animate
const element = $('[data-collage-slider]')[0];
const elementHeight = element.clientHeight;
let flickityLoaded = false;

let sliderJustDragged = false;


// check if element is in view
function inView() {
  // get window height
  var windowHeight = window.innerHeight;
  // get number of pixels that the document is scrolled
  var scrollY = window.scrollY || window.pageYOffset;
  
  // get current scroll position (distance from the top of the page to the bottom of the current viewport)
  var scrollPosition = scrollY + windowHeight;
  // get element position (distance from the top of the page to the bottom of the element)
  var elementPosition = element.getBoundingClientRect().top + scrollY;
  
  // is scroll position greater than element position? (is element in view?)
  if (scrollPosition > elementPosition) {
    return true;
  }
  
  return false;
}

// load element when top is in view
function loadCollageSlider() {
  if (flickityLoaded) return
  else {
    // is element in view?
    if (inView()) {
      flickityLoaded = true;
      // element is in view
      flkty.init();
    }
  }
}


// Check if images are offscreen
jQuery.expr.filters.offscreen = function (el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.x + rect.width < 0 ||
    rect.y + rect.height < 0 ||
    rect.x > window.innerWidth ||
    rect.y > window.innerHeight
  );
};

const checkOffscreenImages = () => {
  const sliderImages = document.querySelectorAll('.collage-slider__image');
  sliderImages.forEach(element => {
    // returns all elements that are offscreen

    // boolean returned if element is offscreen
    if ($(element).is(':offscreen')) {
      $(element).addClass('out-of-frame');
    }
    else {
      $(element).removeClass('out-of-frame');
    }
  })
}


let speedDelta = $('[data-collage-slider]').attr('data-slider-speed');
let sliderSpeed = .4 + (speedDelta / 10);
let loopTriggered = false;

const flkty = {
  init() {
    this.flkty = new Flickity("[data-collage-slider]", {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true, // infinite
      freeScroll: true,
    });
    
    if (loopTriggered == false) {
      this.loop();
      loopTriggered = true;
    }
  },

  reset() {
    speedDelta = $('[data-collage-slider]').attr('data-slider-speed');
    sliderSpeed = .4 + (speedDelta / 10);
    this.flkty.x = 0
  },

  loop() {
    if (!$('html').hasClass('modal-active')) {
      if (!sliderJustDragged) {
        // this.flkty.x--;
        this.flkty.x = this.flkty.x - sliderSpeed;
        this.flkty.integratePhysics();
        this.flkty.settle(this.flkty.x);
      }
    }

    checkOffscreenImages();

    window.requestAnimationFrame(this.loop.bind(this));
  },
};
  

let sliderTimeout,
    pauseTime,
    pauseTimeMS;

const setPauseTime = ()=> {
  pauseTime = $('[data-pause-time]').attr('data-pause-time');
  pauseTimeMS = pauseTime * 1000;
  console.log('SET PAUSE TIME');
  console.log(pauseTimeMS);
}

const pauseSlider = () => {
  sliderJustDragged = true;

  sliderTimeout = setTimeout(() => {
    sliderJustDragged = false
  }, pauseTimeMS);
}

const init = () => {

  setPauseTime();
  
  // ================================================
  // Modal
  // ================================================
  
  const delta = 6;
  let startX;
  let startY;
  let sliderImages = document.querySelectorAll('.collage-slider__image');
  
  sliderImages.forEach(element => {
    element.addEventListener('pointerdown', (event) => {
      startX = event.pageX;
      startY = event.pageY;
    });
    
    element.addEventListener('pointerup', (event) => {
      const diffX = Math.abs(event.pageX - startX);
      const diffY = Math.abs(event.pageY - startY);
  
      if (diffX < delta && diffY < delta) {
        // Click without drag!
        openModal(event);
      }
    });
  })
  
  
  const openModal = (event) => {


    const imageSrc = event.target.getAttribute('src'),
          imageSrcAlt = event.target.getAttribute('alt'),
          $imagewrap = event.target.closest('.collage-slider__image-wrap'),
          title = $($imagewrap).find('[data-image-title]').text(),
          body = $($imagewrap).find('[data-image-body]').text(),
          link = event.target.getAttribute('data-image-link');
  
    if (title !== '') {
      $('[data-collage-modal-title]').show();
      $('[data-collage-modal-title]').text(title);
    }
    else {
      $('[data-collage-modal-title]').hide();
    }
    
    if (body !== '') {
      $('[data-collage-modal-body]').show();
      $('[data-collage-modal-body]').text(body);
    }
    else {
      $('[data-collage-modal-body]').hide();
    }
    
    if (link !== '') {
      $('[data-collage-modal-cta]').show();
      $('[data-collage-modal-cta]').attr('href', link);
    }
    else {
      $('[data-collage-modal-cta]').hide();
    }
  
    $('[data-collage-modal-image]').attr('src', imageSrc);
    $('[data-collage-modal-image]').attr('alt', imageSrcAlt);
  
    $('[data-collage-modal-container]').removeAttr('class').addClass('active');
    $('html').addClass('modal-active');
  }


  // ================================================
  // BIND UI
  // ================================================
  
  // listen for scroll event and call animate function
  document.addEventListener('scroll', loadCollageSlider);

  $('[data-collage-slider]').click(()=> {
    clearTimeout(sliderTimeout);
    pauseSlider();
  });

  $('[data-collage-modal-container]').click((event) => {
    const clickTarget = event.target;

    if (clickTarget.hasAttribute('data-collage-modal-background') || clickTarget.hasAttribute('data-collage-modal-close-button')) {
      $('[data-collage-modal-container]').addClass('out');
      $('html').removeClass('modal-active');
    }
  });
}

init();

//  Detect section reload in theme editor
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    flkty.reset();
    flkty.init();
    init();
  });
}
